<template>
	<div class="content">
		<div class="content-assets">
			<div class="flex-cement">
				<img src="@/assets/Vector@2x.png" style="width: 16px; height: 15px" />
				<div class="cement">我要提现</div>
			</div>
			<div class="border-top"></div>

			<div class="flex-right-paynces">
				<div class="flex-rightTap">
					<div class="flex-rightTap1" @click="switchClick(0)">
						<div class="all-title" :class="{ 'all-title1': idsToar == 0 }">支付宝</div>
						<div class="border-top4" v-if="idsToar == 0"></div>
						<div class="border-top3" v-else></div>
					</div>
					<div class="flex-rightTap1" @click="switchClick(1)">
						<div class="all-title" :class="{ 'all-title1': idsToar == 1 }">银行卡</div>
						<div class="border-top4" v-if="idsToar == 1"></div>
						<div class="border-top3" v-else></div>
					</div>
				</div>
			</div>
			<div class="border-top" style="margin: 0; padding: 0"></div>
			<!-- 		<div class="payment-name">收款姓名</div>
			<div class="payne-title">大连百越科技有限公司</div> -->
			<div class="paynec-account">
				<div class="account-pace">
					<div style="display: flex; align-content: center" v-if="idsToar==0">
						<img src="@/assets/paynec/Vector@2x (1).png" style="width: 18px; height: 18px" />
						<span class="assets-title">支付宝账号</span>
					</div>
					<div style="display: flex; align-content: center" v-else>
						<img src="@/assets/weiyhl.png" style="width: 24px; height: 18px" />
						<span class="assets-title">银行卡账号</span>
					</div>
					<div class="hand-list" style="display: flex; align-content: center" @click="clickAddccount">
						<img src="@/assets/paynec/Group 1272@2x.png" style="width: 18px; height: 18px" />
						<span class="assets-title">增加账号</span>
					</div>
				</div>
			</div>
			<div class="paynec-bordert">
				<div v-for="(item, index) in dataList" :key="index" @click="payneClcik(index)">
					<div class="flex-list-right">
						<div class="flex-left-pay">
							<img src="@/assets/paynec/Group 1480@2x.png" v-if="index == ids" style="margin-top: 4px; width: 13px; height: 13px" />
							<img src="@/assets/paynec/Ellipse 11@2x.png" v-else style="margin-top: 4px; width: 13px; height: 13px" />
							<div class="flex-leist">
								<div v-if="idsToar==0">支付宝账号</div>
								<div v-else>银行卡账号</div>
								<div class="leist">{{ item.payCode }}</div>
							</div>
						</div>
						<div class="flex-left-pay" @click="memberAccountDeleteClci(item)">
							<img src="@/assets/Vector@2x (2).png" style="width: 11px; height: 12px" />
							<div class="leis-name" style="margin-top: -5px; margin-left: 10px; color: #ec3925">删除账号</div>
						</div>
					</div>
					<div class="border-card"></div>
				</div>
			</div>

			<div class="flex-card-left">
				<div class="flex-title">提现金额</div>
				<div class="flex-pring">可提现金额 ：￥{{ userInfo.amount }}</div>
			</div>
			<div class="inputVue">
				<div class="flex-cement-left">
					<span class="flex-input">¥</span>
					<input placeholder="单笔最高5000元,单日限额20万元(实时到账),手续费:2元/笔" class="input" v-model="amount" />
				</div>
			</div>
			<div class="text-list" style="width: 410px">提现时间:8:30~23:00,提现间隔30分钟不可提交重复金额。每日自动到账次数有限。未到账请联系客服。</div>

			<div class="text-list-parint" v-if="0">验证码</div>
			<div v-if="0" class="inputVue" style="display: flex; justify-content: space-between">
				<div class="flex-cement-left">
					<span class="flex-input">¥</span>
					<input placeholder="输入验证码" class="input" style="width: 100px" />
				</div>
				<div class="flex-slice-const">
					<img src="../../../assets/Vector@2x.png" />
				</div>
			</div>
			<div class="text-list" style="width: 410px">佐证材料，最多4张。</div>
			<el-upload
				:limit="4"
				style="margin-top: 10px; margin-left: 10px"
				v-model="fileList"
				action="https://mobile.jingkashou.com/api/app-api/infra/file/upload"
				list-type="picture-card"
				:on-success="handleAvatarSuccess"
				:on-remove="handleRemove"
			>
				<el-icon><Plus /></el-icon>
			</el-upload>

			<el-dialog v-model="dialogVisible">
				<img w-full :src="dialogImageUrl" alt="Preview Image" />
			</el-dialog>

			<div class="text-list" style="width: 410px">提供相关购卡/赠送证明，可加快到账时间。</div>

			<div class="withdrawal" @click="withdrawalClick">确认提现</div>
		</div>
	</div>
	<div class="bjMy" v-if="showBjMy">
		<div class="message">
			<div class="mess-img" @click="clickAddccount">
				<img src="@/assets/Group 1271@2x.png" style="height: 35px; width: 35px" />
			</div>
			<div>
				<div class="message-title">
					<div>
						<img src="@/assets/paynec/Group 1315@2x.png" style="width: 16px; height: 16px" />
					</div>
					<div style="margin-left: 5px" v-if="idsToar==0">增加支付宝账号</div>
					<div style="margin-left: 5px" v-else>增加银行卡账号</div>
				</div>
			</div>
			<div class="message-border"></div>
			<div class="input-bot" style="margin-top: 22px">
				<div style="margin-left: 14px; margin-top: 3px">
					<img src="@/assets/paynec/Group 903@2x.png" style="width: 14px; height: 16px" />
				</div>
				<div style="margin-left: 8px">
					真实姓名
					<input v-model="userInfo.realName" disabled placeholder="真实姓名" class="inputSuni" />
				</div>
			</div>
			<div class="input-bot">
				<div style="margin-left: 14px; margin-top: 3px">
					<img src="@/assets/paynec/Union@2x.png" style="width: 14px; height: 10px" />
				</div>
				<div style="margin-left: 8px">
					身份证号
					<input v-model="userInfo.idCard" disabled placeholder="身份证号" class="inputSuni" />
				</div>
			</div>
			<div class="input-bot">
				<div style="margin-left: 14px; margin-top: 3px">
					<img v-if="idsToar==0" src="@/assets/paynec/Vector@2x (4).png" style="width: 14px; height: 14px" />
					<img v-if="idsToar!=0" src="@/assets/weiyhl.png" style="width: 14px; height: 14px" />
				</div>
				<div style="margin-left: 8px" v-if="idsToar==0">
					<input placeholder="请输入支付宝账号" v-model="payCode" class="inputSuni" />
				</div>
				<div style="margin-left: 8px" v-else>
					<input placeholder="请输入银行卡账号" v-model="payCode" class="inputSuni" />
				</div>
			</div>
			<div class="sure-you-want" @click="sureClick">确认提交</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onActivated, reactive } from 'vue';
import { memberCreate, memberAccountList, memberAccountDelete, cardPayCreate } from '@/utils/api.js';
import { ElMessage, ElMessageBox, UploadProps, UploadUserFile } from 'element-plus';
import { Plus } from '@element-plus/icons-vue';

const emit = defineEmits(['withdrawSuccess']);
let showBjMy = ref(false);
let payCode = ref('');
let dataList = ref([]);
let userInfo = ref({});
let imageList = ref([]);
let ids = ref(999);
let idsToar = ref(0);
let amount = ref('');
const fileLis = ref([]);

const tabMaps = [
	{
		name: '支付宝',
		value: 'ali'
	},
	{
		name: '银行卡',
		value: 'bank'
	}
];

const clickAddccount = () => {
	payCode.value = '';
	showBjMy.value = !showBjMy.value;
};

const dialogImageUrl = ref('');
const dialogVisible = ref(false);

const handleAvatarSuccess = (uploadFile, uploadFiles) => {
	imageList.value.push(uploadFile.data);
};
const handleRemove = (uploadFile, uploadFiles) => {
	imageList.value = [];
	uploadFiles.forEach((item) => {
		imageList.value.push(item);
	});
};

const sureClick = async () => {
	let res = await memberCreate({
		payCode: payCode.value,
		type: tabMaps[idsToar.value].value
	});
	clickAddccount();
	infoToar();
};
const infoToar = async () => {
	let res = await memberAccountList({
		type: tabMaps[idsToar.value].value
	});
	dataList.value = res.data;
};
const memberAccountDeleteClci = (item) => {
	ElMessageBox.confirm('是否删除？', '提示', {
		type: 'warning'
	})
		.then(async () => {
			let res = await memberAccountDelete({ id: item.id });
			infoToar();
		})
		.catch((err) => {});
};
const payneClcik = async (item) => {
	ids.value = item;
};
const withdrawalClick = async () => {
	if (ids.value == 999) {
		ElMessage.error('请选择支付方式');
		return false;
	}
	if (!amount.value) {
		ElMessage.error('请输入金额');
		return false;
	}
	try {
		await ElMessageBox.confirm(`确认提现 ¥${amount.value} 吗？`, '提现确认', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		});
	} catch {
		return;
	}
	let imageObj = '';
	if (imageList.value.length) {
		imageObj = imageList.value.join(',');
	}
	try {
		const res = await cardPayCreate({
			amount: amount.value,
			payChannel: tabMaps[idsToar.value].value,
			receiveCode: dataList.value[ids.value].payCode,
			type: 'normal',
			imageUrl: imageObj
		});
		if (res.code === 0) {
			ElMessage.success('提现申请提交成功');
			amount.value = '';
			imageList.value = [];
			emit('withdrawSuccess');
		} else {
			ElMessage.error(res.msg || '提现失败');
		}
	} catch (error) {
		console.error('提现失败:', error);
	}
};
const switchClick = (item) => {
	idsToar.value = item;
	infoToar();
};
const syncUserInfo = () => {
	const stored = localStorage.getItem('information');
	userInfo.value = stored ? JSON.parse(stored) : {};
};

onMounted(() => {
	infoToar();
	syncUserInfo();
});

onActivated(() => {
	syncUserInfo();
});
</script>

<style lang="scss" scoped>
.content-assets {
	padding: 20px 21px;
	padding-: 26px;
}

.content {
	width: 85%;
	background-color: #fff;
	margin-left: 20px;
	margin-left: auto;
}

.flex-cement {
	position: relative;
	display: flex;
	align-items: center;

	.cement {
		font-family: PingFang SC, PingFang SC;
		font-weight: 600;
		font-size: 20px;
		color: #333333;
		margin-left: 8px;
		font-style: normal;
		text-transform: none;
	}
}

.flex-contact-slices {
	position: absolute;
	top: 0;
	right: 0;
	display: flex;
	align-items: center;
}

.assets-return {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 4px;
	margin-top: 2px;
}

.border-top {
	width: 99%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 16px;
	padding-top: 16px;
}

.flex-const-slice {
	display: flex;
	margin-top: 10px;
}
.title-slice {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 18px;
	color: #333333;
	text-align: left;
	font-style: normal;
	text-transform: none;
	margin-top: 2px;
}

.title-slice1 {
	color: #ff2f17;
}

.december {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 17px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
	margin-top: -2px;
}

.flex-top {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.ulGrop {
	li {
		width: 263px;
		height: 30px;
		font-family: PingFang SC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		line-height: 30px;
		text-align: left;
		font-style: normal;
		text-transform: none;
	}
}
.title-align {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	line-height: 16px;
	text-align: center;
	font-style: normal;
	text-transform: none;
}

.payment-name {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}

.payne-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-top: 4px;
}

.paynec-account {
	width: 410px;
	background: #fafafa;
	border: 1px solid #eeeeee;
	margin-top: 22px;
}

.account-pace {
	padding: 10px 14px;
	display: flex;
	justify-content: space-between;
}

.assets-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-left: 5px;
}
.paynec-bordert {
	width: 410px;
	background: #ffffff;
	border: 1px solid #eeeeee;
}

.flex-left-pay {
	display: flex;
}
.flex-leist {
	margin-left: 10px;
}
.leist {
	font-family: PingFang SC, PingFang SC;
	font-weight: 500;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-top: -5px;
}
.leis-name {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.flex-list-right {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 17px 14px;
}

.border-card {
	width: 282px;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-left: 17px;
}

.flex-card-left {
	display: flex;
	align-items: center;
	width: 410px;
	margin-top: 24px;
}
.flex-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.flex-pring {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #ec3925;
	text-align: right;
	font-style: normal;
	text-transform: none;
	margin-left: auto;
}
.input {
	outline: none;
	border: none;
	margin-left: 10px;
	font-family: PingFang SC, PingFang SC;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	width: 350px;
}
.input:focus {
	outline: none;
	border: none;
}

.inputVue {
	width: 410px;
	height: 52px;
	background: #ffffff;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	margin-top: 9px;
}
.flex-input {
	font-size: 12px;
	color: #333333;
}
.flex-cement-left {
	padding: 15px 12px;
}
.input::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-size: 13px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}
.text-list {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-top: 8px;
	margin-left: 10px;
}

.text-list-parint {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #333333;
	font-style: normal;
	text-transform: none;
	margin-top: 22px;
	margin-left: 10px;
}

.flex-slice-const {
	width: 110px;
	height: 52px;
	background: #ffffff;
	border: 1px solid #eeeeee;
	display: flex;
	align-items: center;
	justify-content: center;
}

.withdrawal {
	width: 162px;
	height: 42px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #ff3333;
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #ffffff;
	line-height: 19px;
	text-align: left;
	font-style: normal;
	text-transform: none;
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #ffffff;
	line-height: 42px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 30px;
}
.flex-assets-left {
	display: flex;
	align-content: center;
	margin-top: 26px;
}

.titm-assets {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 12px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-left: 6px;
}

.withdrawal:hover {
	cursor: pointer;
}

.bjMy {
	position: fixed;
	width: 100%;
	height: calc(100% - 70px);
	background: rgba(0, 0, 0, 0.7);
	z-index: 1000;
	bottom: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
}

.message {
	width: 458px;
	height: 364px;
	background: #ffffff;
	border-radius: 8px 8px 8px 8px;
	position: relative;
}

.mess-img {
	position: absolute;
	right: -15px;
	top: -15px;
}

.message-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 20px;
	color: #333333;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 21px;
	display: flex;
	justify-content: center;
}
.message-border {
	width: 100%;
	height: 0px;
	border-top: 1px solid #eeeeee;
	margin-top: 11px;
}

.slicess {
	padding: 0px 40px;
}
.slicess-padd {
	margin-top: 22px;
}

.title-sliceS {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #333333;
	font-style: normal;
	text-transform: none;
}
.title-time1 {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-top: 7px;
}

.pagination-contact1 {
	position: absolute;
	bottom: 30px;
	left: 50px;
}

.input-bot {
	width: 410px;
	height: 42px;
	border-radius: 4px 4px 4px 4px;
	border: 1px solid #eeeeee;
	display: flex;
	align-items: center;
	margin-left: 24px;
	margin-top: 14px;
}
.inputSuni {
	outline: none;
	border: none;
	font-size: 16px;
	font-style: normal;
	text-transform: none;
}

.inputSuni::placeholder {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
}

.inputSuni:focus {
	outline: none;
	border: none;
}

.sure-you-want {
	width: 410px;
	height: 52px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 52px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 24px;
	margin-top: 47px;
}
.sure-you-want:hover {
	cursor: pointer;
}

.hand-list:hover {
	cursor: pointer;
}

.flex-right-paynces {
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.flex-rightTap {
	display: flex;
	align-items: center;
	margin-left: -34px;
}

.flex-rightTap1 {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin-left: 54px;
}

.flex-rightTap:hover {
	cursor: pointer;
}

.all-title1 {
	color: #ec3925;
}

.flex-date-filter {
	display: flex;
	align-content: center;
	align-items: center;
	margin-top: -16px;
}

.date-filter {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #aaaaaa;
	font-style: normal;
	text-transform: none;
	margin-right: 10px;
}

.query-title {
	width: 52px;
	height: 32px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #ffffff;
	line-height: 32px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-left: 11px;
}

.imagAser:hover {
	cursor: pointer;
}

.border-top4 {
	width: 29px;
	height: 2px;
	background: #ec3925;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
.border-top3 {
	width: 29px;
	height: 2px;
	border-radius: 0px 0px 0px 0px;
	margin-top: 13px;
}
</style>
